module.exports = __webpack_public_path__ + "static/media/logoNegative.5273bff2.svg";